import React from 'react'
import clsx from 'clsx'

import * as styles from './videolist.module.scss'

type VideoListProps = React.ComponentProps<'div'> & {
  children: React.ReactNode
}

export const VideoList = ({
  children,
  className,
  ...props
}: VideoListProps) => (
  <div className={clsx(styles.videolist, className)} {...props}>
    {children}
  </div>
)
